import { formatPageTitle } from '@/utils/index'


const asyncRouters = [
    // Dashboard
    {
        path: '/dashboard',
        component: () => import(/* webpackChunkName: "dashboard" */ '../views/dashboard/Index.vue'),
        name: 'Dashboard',
        meta: { name: 'Dashboard', code: 'dashboard', pageTitle: formatPageTitle('Dashboard')}
    },

    // Radar
    {
        path: '/radar',
        component: () => import(/* webpackChunkName: "radar" */ '../views/radar/Index.vue'),
        name: 'Radar',
        meta: { name: 'Radar Map', code: 'radar', pageTitle: formatPageTitle('Radar Map')}
    },

    // Cast
    {
        path: '/cast',
        component: () => import(/* webpackChunkName: "radar" */ '../views/radar/Index.vue'),
        name: 'Radar Cast',
        meta: { name: 'Radar Cast Map', code: 'radar', pageTitle: formatPageTitle('Radar Cast Map'), fullScreen: true}
    },

    // Bus
    {
        path: '/bus',
        component: () => import(/* webpackChunkName: "bus" */ '../views/bus/Index.vue'),
        meta: { name: 'Bus', code: 'bus', pageTitle: formatPageTitle('Bus')},
        children: [
            {
                path: '',
                component: () => import(/* webpackChunkName: "bus" */ '../views/bus/Buses.vue'),
                name: 'Bus',
                meta: { name: 'Bus', pageTitle: formatPageTitle('Bus'), keepAlive: true},
            },
            {
                path: 'add',
                component: () => import(/* webpackChunkName: "bus" */ '../views/bus/actions/Index.vue'),
                name: 'Add Bus',
                meta: { name: 'Add Bus', pageTitle: formatPageTitle('Add Bus')},
            },
            {
                path: ':id(\\d+)?/edit',
                component: () => import(/* webpackChunkName: "bus" */ '../views/bus/actions/Index.vue'),
                name: 'Edit Bus',
                meta: { name: 'Edit Bus', pageTitle: formatPageTitle('Edit Bus')},
            },
            {
                path: ':id(\\d+)?/edit-picture',
                component: () => import(/* webpackChunkName: "bus" */ '../views/bus/actions/Gallery.vue'),
                name: 'Edit Bus Picture',
                meta: { name: 'Edit Bus Picture', pageTitle: formatPageTitle('Edit Bus Picture')},
            },
            {
                path: ':id(\\d+)?',
                component: () => import(/* webpackChunkName: "bus" */ '../views/bus/details/Index.vue'),
                meta: { name: 'Bus Details', pageTitle: formatPageTitle('Bus Details')},
                children: [
                    {
                        path: '',
                        component: () => import(/* webpackChunkName: "bus" */ '../views/bus/details/Details.vue'),
                        name: 'Bus Details',
                        meta: { name: 'Bus Details', tabname: 'overview', pageTitle: formatPageTitle('Bus Details')},
                    },
                    {
                        path: 'routes',
                        component: () => import(/* webpackChunkName: "bus" */ '../views/bus/details/Routes.vue'),
                        name: 'Bus Routes',
                        meta: { name: 'Bus Routes', tabname: 'routes', pageTitle: formatPageTitle('Bus Routes')},
                    },
                    {
                        path: 'tracks',
                        component: () => import(/* webpackChunkName: "bus" */ '../views/bus/details/Tracks.vue'),
                        name: 'Bus Tracks',
                        meta: { name: 'Bus Tracks', tabname: 'tracks', pageTitle: formatPageTitle('Bus Tracks')},
                    },
                    {
                        path: 'inspections',
                        component: () => import(/* webpackChunkName: "bus" */ '../views/bus/details/Inspections.vue'),
                        name: 'Bus Inspections',
                        meta: { name: 'Bus Inspections', tabname: 'inspections', pageTitle: formatPageTitle('Bus Inspections')},
                    },
                    {
                        path: 'defects',
                        component: () => import(/* webpackChunkName: "bus" */ '../views/bus/details/Defects.vue'),
                        name: 'Bus Defects',
                        meta: { name: 'Bus Defects', tabname: 'defects', pageTitle: formatPageTitle('Bus Defects')},
                    },
                    {
                        path: 'schedule',
                        component: () => import(/* webpackChunkName: "bus" */ '../views/bus/details/Schedule.vue'),
                        name: 'Bus Schedule',
                        meta: { name: 'Bus Schedule', tabname: 'schedule', pageTitle: formatPageTitle('Bus Schedule')},
                    },
                    {
                        path: 'registration_code',
                        component: () => import(/* webpackChunkName: "bus" */ '../views/bus/details/registration-code/Index.vue'),
                        name: 'Bus Registration Code',
                        meta: { name: 'Bus Registration Code', tabname: 'registration_code', pageTitle: formatPageTitle('Bus Registration Code')},
                    },
                    {
                        path: 'logs',
                        component: () => import(/* webpackChunkName: "bus" */ '../views/bus/details/Logs.vue'),
                        name: 'Bus Logs',
                        meta: { name: 'Bus Logs', tabname: 'logs', pageTitle: formatPageTitle('Bus Logs')},
                    },
                ]
            },
        ]
    },

    // Bus Yard
    {
        path: '/bus_yard',
        component: () => import(/* webpackChunkName: "bus-yard" */ '../views/bus/Index.vue'),
        meta: { name: 'Bus Yard', code: 'bus_yard', pageTitle: formatPageTitle('Bus')},
        children: [
            {
                path: '',
                component: () => import(/* webpackChunkName: "bus-yard" */ '../views/bus-yard/BusYards.vue'),
                name: 'Bus Yard',
                meta: { name: 'Bus Yard', pageTitle: formatPageTitle('Bus Yard'), keepAlive: true},
            },
            {
                path: 'add',
                component: () => import(/* webpackChunkName: "bus-yard" */ '../views/bus-yard/actions/Index.vue'),
                name: 'Add Bus Yard',
                meta: { name: 'Add Bus Yard', pageTitle: formatPageTitle('Add Bus Yard')},
            },
            {
                path: ':id(\\d+)?/edit',
                component: () => import(/* webpackChunkName: "bus-yard" */ '../views/bus-yard/actions/Index.vue'),
                name: 'Edit Bus Yard',
                meta: { name: 'Edit Bus Yard', pageTitle: formatPageTitle('Edit Bus Yard')},
            },
            {
                path: ':id(\\d+)?',
                component: () => import(/* webpackChunkName: "bus-yard" */ '../views/bus-yard/details/Index.vue'),
                meta: { name: 'Bus Yard Details', pageTitle: formatPageTitle('Bus Yard Details')},
                children: [
                    {
                        path: '',
                        component: () => import(/* webpackChunkName: "bus-yard" */ '../views/bus-yard/details/Details.vue'),
                        name: 'Bus Yard Details',
                        meta: { name: 'Bus Yard Details', tabname: 'overview', pageTitle: formatPageTitle('Bus Yard Details')},
                    },
                ]
            },
        ]
    },

    // Driver
    {
        path: '/driver',
        component: () => import(/* webpackChunkName: "driver" */ '../views/driver/Index.vue'),
        meta: { name: 'Driver', code: 'driver', pageTitle: formatPageTitle('Driver')},
        children: [
            {
                path: '',
                component: () => import(/* webpackChunkName: "driver" */ '../views/driver/Drivers.vue'),
                name: 'Driver',
                meta: { name: 'Driver', pageTitle: formatPageTitle('Driver'), keepAlive: true},
            },
            {
                path: 'add',
                component: () => import(/* webpackChunkName: "driver" */ '../views/driver/actions/Index.vue'),
                name: 'Add Driver',
                meta: { name: 'Add Driver', pageTitle: formatPageTitle('Add Driver')},
            },
            {
                path: ':id(\\d+)?/edit',
                component: () => import(/* webpackChunkName: "driver" */ '../views/driver/actions/Index.vue'),
                name: 'Edit Driver',
                meta: { name: 'Edit Driver', pageTitle: formatPageTitle('Edit Driver')},
            },
            {
                path: ':id(\\d+)?/edit-picture',
                component: () => import(/* webpackChunkName: "driver" */ '../views/driver/actions/Gallery.vue'),
                name: 'Edit Driver Avatar',
                meta: { name: 'Edit Driver Avatar', pageTitle: formatPageTitle('Edit Driver Avatar')},
            },
            {
                path: ':id(\\d+)?',
                component: () => import(/* webpackChunkName: "driver" */ '../views/driver/details/Index.vue'),
                meta: { name: 'Driver Details', pageTitle: formatPageTitle('Driver Details')},
                children: [
                    {
                        path: '',
                        component: () => import(/* webpackChunkName: "driver" */ '../views/driver/details/Details.vue'),
                        name: 'Driver Details',
                        meta: { name: 'Driver Details', tabname: 'overview', pageTitle: formatPageTitle('Driver Details')},
                    },
                    {
                        path: 'routes',
                        component: () => import(/* webpackChunkName: "driver" */ '../views/driver/details/Routes.vue'),
                        name: 'Driver Routes',
                        meta: { name: 'Driver Routes', tabname: 'routes', pageTitle: formatPageTitle('Driver Routes')},
                    },
                    {
                        path: 'logs',
                        component: () => import(/* webpackChunkName: "driver" */ '../views/driver/details/Logs.vue'),
                        name: 'Driver Logs',
                        meta: { name: 'Driver Logs', tabname: 'logs', pageTitle: formatPageTitle('Driver Logs')},
                    },
                    {
                        path: 'inspections',
                        component: () => import(/* webpackChunkName: "driver" */ '../views/driver/details/Inspections.vue'),
                        name: 'Driver Inspections',
                        meta: { name: 'Driver Inspections', tabname: 'inspections', pageTitle: formatPageTitle('Driver Inspections')},
                    },
                    {
                        path: 'defects',
                        component: () => import(/* webpackChunkName: "driver" */ '../views/driver/details/Defects.vue'),
                        name: 'Driver Defects',
                        meta: { name: 'Driver Defects', tabname: 'defects', pageTitle: formatPageTitle('Driver Defects')},
                    },
                    {
                        path: 'performance',
                        component: () => import(/* webpackChunkName: "driver" */ '../views/driver/details/Performance.vue'),
                        name: 'Driver Performance',
                        meta: { name: 'Driver Performance', tabname: 'performance', pageTitle: formatPageTitle('Driver Performance')},
                    },
                ]
            },
        ]
    },

    // Device
    {
        path: '/device',
        component: () => import(/* webpackChunkName: "device" */ '../views/device/Index.vue'),
        meta: { name: 'Device', code: 'device', pageTitle: formatPageTitle('Device')},
        children: [
            {
                path: '',
                component: () => import(/* webpackChunkName: "device" */ '../views/device/Devices.vue'),
                name: 'Device',
                meta: { name: 'Device', pageTitle: formatPageTitle('Device'), keepAlive: true},
            },
            {
                path: 'map',
                component: () => import(/* webpackChunkName: "device" */ '../views/device/Map.vue'),
                name: 'Device Map',
                meta: { name: 'Device Map', pageTitle: formatPageTitle('Device Map'), keepAlive: true},
            },
            {
                path: ':id(\\d+)?/edit',
                component: () => import(/* webpackChunkName: "device" */ '../views/device/actions/Index.vue'),
                name: 'Edit Device',
                meta: { name: 'Edit Device', pageTitle: formatPageTitle('Edit Device')},
            },
            {
                path: ':id(\\d+)?',
                component: () => import(/* webpackChunkName: "device" */ '../views/device/details/Index.vue'),
                meta: { name: 'Device Details', pageTitle: formatPageTitle('Device Details')},
                children: [
                    {
                        path: '',
                        component: () => import(/* webpackChunkName: "device" */ '../views/device/details/Details.vue'),
                        name: 'Device Details',
                        meta: { name: 'Device Details', tabname: 'overview', pageTitle: formatPageTitle('Device Details')},
                    },
                    {
                        path: 'tracks',
                        component: () => import(/* webpackChunkName: "device" */ '../views/device/details/Tracks.vue'),
                        name: 'Device Tracks',
                        meta: { name: 'Device Tracks', tabname: 'tracks', pageTitle: formatPageTitle('Device Tracks')},
                    },
                ]
            },
        ]
    },
    // Device
    {
        path: '/external_device',
        component: () => import(/* webpackChunkName: "external-device" */ '../views/external-device/Index.vue'),
        meta: { name: 'External Device', code: 'external_device', pageTitle: formatPageTitle('External Device')},
        children: [
            {
                path: '',
                component: () => import(/* webpackChunkName: "external-device" */ '../views/external-device/Devices.vue'),
                name: 'External Device',
                meta: { name: 'External Device', pageTitle: formatPageTitle('External Device'), keepAlive: true},
            },
            {
                path: 'map',
                component: () => import(/* webpackChunkName: "external-device" */ '../views/external-device/Map.vue'),
                name: 'Devices Map',
                meta: { name: 'External Device Map', pageTitle: formatPageTitle('External Device Map'), keepAlive: true},
            },
            {
                path: ':id(\\d+)?/edit',
                component: () => import(/* webpackChunkName: "external-device" */ '../views/external-device/actions/Index.vue'),
                name: 'Edit External Device',
                meta: { name: 'Edit External Device', pageTitle: formatPageTitle('Edit External Device')},
            },
            {
                path: ':id(\\d+)?',
                component: () => import(/* webpackChunkName: "external-device" */ '../views/external-device/details/Index.vue'),
                meta: { name: 'External Device Details', pageTitle: formatPageTitle('External Device Details')},
                children: [
                    {
                        path: '',
                        component: () => import(/* webpackChunkName: "external-device" */ '../views/external-device/details/Details.vue'),
                        name: 'External Device Details',
                        meta: { name: 'External Device Details', tabname: 'overview', pageTitle: formatPageTitle('External Device Details')},
                    },
                    {
                        path: 'tracks',
                        component: () => import(/* webpackChunkName: "external-device" */ '../views/external-device/details/Tracks.vue'),
                        name: 'External Device Tracks',
                        meta: { name: 'External Device Tracks', tabname: 'tracks', pageTitle: formatPageTitle('External Device Tracks')},
                    },
                ]
            },
        ]
    },

    // Student
    {
        path: '/student',
        component: () => import(/* webpackChunkName: "student" */ '../views/student/Index.vue'),
        meta: { name: 'Student', code: 'student', pageTitle: formatPageTitle('Student')},
        children: [
            {
                path: '',
                component: () => import(/* webpackChunkName: "student" */ '../views/student/Students.vue'),
                name: 'Student',
                meta: { name: 'Student', pageTitle: formatPageTitle('Student'), keepAlive: true},
            },
            {
                path: 'add',
                component: () => import(/* webpackChunkName: "student" */ '../views/student/actions/Index.vue'),
                name: 'Add Student',
                meta: { name: 'Add Student', pageTitle: formatPageTitle('Add Student')},
            },
            {
                path: ':id(\\d+)?/edit',
                component: () => import(/* webpackChunkName: "student" */ '../views/student/actions/Index.vue'),
                name: 'Edit Student',
                meta: { name: 'Edit Student', pageTitle: formatPageTitle('Edit Student')},
            },
            {
                path: ':id(\\d+)?/edit-picture',
                component: () => import(/* webpackChunkName: "student" */ '../views/student/actions/Gallery.vue'),
                name: 'Edit Student Avatar',
                meta: { name: 'Edit Student Avatar', pageTitle: formatPageTitle('Edit Student Avatar')},
            },
            // {
            //     path: ':id(\\d+)?/add-skip-request',
            //     component: () => import(/* webpackChunkName: "student" */ '../views/student/actions/SkipRequest.vue'),
            //     name: 'Add Skip Request',
            //     meta: { name: 'Add Skip Request', pageTitle: formatPageTitle('Add Skip Request')},
            // },
            // {
            //     path: ':id(\\d+)?/edit-skip-request/:itemid(\\d+)?',
            //     component: () => import(/* webpackChunkName: "student" */ '../views/student/actions/SkipRequest.vue'),
            //     name: 'Edit Skip Request',
            //     meta: { name: 'Edit Skip Request', pageTitle: formatPageTitle('Edit Skip Request')},
            // },
            {
                path: ':id(\\d+)?',
                component: () => import(/* webpackChunkName: "student" */ '../views/student/details/Index.vue'),
                meta: { name: 'Student Details', pageTitle: formatPageTitle('Student Details')},
                children: [
                    {
                        path: '',
                        component: () => import(/* webpackChunkName: "student" */ '../views/student/details/Details.vue'),
                        name: 'Student Details',
                        meta: { name: 'Student Details', tabname: 'overview', pageTitle: formatPageTitle('Student Details')},
                    },
                    {
                        path: 'guardians',
                        component: () => import(/* webpackChunkName: "student" */ '../views/student/details/guardians/Index.vue'),
                        name: 'Student Guardians',
                        meta: { name: 'Student Guardians', tabname: 'guardians', pageTitle: formatPageTitle('Student Guardians')},
                    },
                    {
                        path: 'routes',
                        component: () => import(/* webpackChunkName: "student" */ '../views/student/details/Routes.vue'),
                        name: 'Student Routes',
                        meta: { name: 'Student Routes', tabname: 'routes', pageTitle: formatPageTitle('Student Routes')},
                    },
                    {
                        path: 'cards',
                        component: () => import(/* webpackChunkName: "student" */ '../views/student/details/Cards.vue'),
                        name: 'Student Cards',
                        meta: { name: 'Student Cards', tabname: 'cards', pageTitle: formatPageTitle('Student Cards')},
                    },
                    {
                        path: 'skip_request',
                        component: () => import(/* webpackChunkName: "student" */ '../views/student/details/skip-request/Index.vue'),
                        name: 'Student Skip Request',
                        meta: { name: 'Student Skip Request', tabname: 'skip_request', pageTitle: formatPageTitle('Student Skip Request')},
                    },
                    {
                        path: 'skip_request/add',
                        component: () => import(/* webpackChunkName: "student" */ '../views/student/details/skip-request/Add.vue'),
                        name: 'Add Student Skip Request',
                        meta: { name: 'Add Student Skip Request', notemplate: true, exclude: true, pageTitle: formatPageTitle('Add Student Skip Request')},
                    },
                    {
                        path: 'skip_request/:itemid(\\d+)?',
                        component: () => import(/* webpackChunkName: "student" */ '../views/student/details/skip-request/Add.vue'),
                        name: 'Edit Student Skip Request',
                        meta: { name: 'Edit Student Skip Request', notemplate: true, exclude: true, pageTitle: formatPageTitle('Edit Student Skip Request')},
                    },
                    {
                        path: 'busing',
                        component: () => import(/* webpackChunkName: "student" */ '../views/student/details/Busing.vue'),
                        name: 'Student Busing',
                        meta: { name: 'Student Busing', tabname: 'busing', pageTitle: formatPageTitle('Student Busing')},
                    },
                    {
                        path: 'registration_code',
                        component: () => import(/* webpackChunkName: "student" */ '../views/student/details/registration-code/Index.vue'),
                        name: 'Student Registration Code',
                        meta: { name: 'Student Registration Code', tabname: 'registration_code', pageTitle: formatPageTitle('Student Registration Code')},
                    },
                    {
                        path: 'programs',
                        component: () => import(/* webpackChunkName: "student" */ '../views/student/details/programs/Index.vue'),
                        name: 'Student Programs',
                        meta: { name: 'Student Programs', tabname: 'programs', pageTitle: formatPageTitle('Student Programs')},
                    },
                    {
                        path: 'addresses',
                        component: () => import(/* webpackChunkName: "student" */ '../views/student/details/addresses/Index.vue'),
                        name: 'Student Addresses',
                        meta: { name: 'Student Addresses', tabname: 'addresses', pageTitle: formatPageTitle('Student Addresses')},
                    },
                    {
                        path: 'transportation-plans',
                        component: () => import(/* webpackChunkName: "student" */ '../views/student/details/transportation-plans/Index.vue'),
                        name: 'Student Transportation Plans',
                        meta: { name: 'Student Transportation Plans', tabname: 'transportation-plans', pageTitle: formatPageTitle('Student Transportation Plans')},
                    },
                ]
            },
            {
                path: 'group',
                component: () => import(/* webpackChunkName: "student" */ '../views/student-group/Index.vue'),
                meta: { name: 'Student Group', pageTitle: formatPageTitle('Student Group')},
                children: [
                    {
                        path: '',
                        component: () => import(/* webpackChunkName: "student" */ '../views/student-group/Groups.vue'),
                        name: 'Student Group',
                        meta: { name: 'Student Group', pageTitle: formatPageTitle('Student Group'), keepAlive: true},
                    },
                    {
                        path: 'add',
                        component: () => import(/* webpackChunkName: "student" */ '../views/student-group/actions/Index.vue'),
                        name: 'Add Student Group',
                        meta: { name: 'Add Student Group', pageTitle: formatPageTitle('Add Student Group')},
                    },
                    {
                        path: ':id(\\d+)?/edit',
                        component: () => import(/* webpackChunkName: "student" */ '../views/student-group/actions/Index.vue'),
                        name: 'Edit Student Group',
                        meta: { name: 'Edit Student Group', pageTitle: formatPageTitle('Edit Student Group')},
                    },
                    {
                        path: ':id(\\d+)?',
                        component: () => import(/* webpackChunkName: "student" */ '../views/student-group/details/Index.vue'),
                        meta: { name: 'Student Group Details', pageTitle: formatPageTitle('Student Group Details')},
                        children: [
                            {
                                path: '',
                                component: () => import(/* webpackChunkName: "student" */ '../views/student-group/details/Details.vue'),
                                name: 'Student Group Details',
                                meta: { name: 'Student Group Details', tabname: 'overview', pageTitle: formatPageTitle('Student Group Details')},
                            },
                            {
                                path: 'students',
                                component: () => import(/* webpackChunkName: "student" */ '../views/student-group/details/students/Index.vue'),
                                name: 'Group Students',
                                meta: { name: 'Group Students', tabname: 'students', pageTitle: formatPageTitle('Group Students')},
                            },
                        ]
                    }
                ]
            }
        ]
    },

    // Guardian
    {
        path: '/guardian',
        component: () => import(/* webpackChunkName: "guardian" */ '../views/guardian/Index.vue'),
        meta: { name: 'Guardian', code: 'guardian', pageTitle: formatPageTitle('Guardian')},
        children: [
            {
                path: '',
                component: () => import(/* webpackChunkName: "guardian" */ '../views/guardian/Guardians.vue'),
                name: 'Guardian',
                meta: { name: 'Guardian', pageTitle: formatPageTitle('Guardian'), keepAlive: true},
            },
            {
                path: 'add',
                component: () => import(/* webpackChunkName: "guardian" */ '../views/guardian/actions/Index.vue'),
                name: 'Add Guardian',
                meta: { name: 'Add Guardian', pageTitle: formatPageTitle('Add Guardian')},
            },
            {
                path: ':id(\\d+)?/edit',
                component: () => import(/* webpackChunkName: "guardian" */ '../views/guardian/actions/Index.vue'),
                name: 'Edit Guardian',
                meta: { name: 'Edit Guardian', pageTitle: formatPageTitle('Edit Guardian')},
            },
            {
                path: ':id(\\d+)?',
                component: () => import(/* webpackChunkName: "guardian" */ '../views/guardian/details/Index.vue'),
                meta: { name: 'Guardian Details', pageTitle: formatPageTitle('Guardian Details')},
                children: [
                    {
                        path: '',
                        component: () => import(/* webpackChunkName: "guardian" */ '../views/guardian/details/Details.vue'),
                        name: 'Guardian Details',
                        meta: { name: 'Guardian Details', tabname: 'overview', pageTitle: formatPageTitle('Guardian Details')},
                    },
                    {
                        path: 'students',
                        component: () => import(/* webpackChunkName: "guardian" */ '../views/guardian/details/students/Index.vue'),
                        name: 'Guardian Students',
                        meta: { name: 'Guardian Students', tabname: 'students', pageTitle: formatPageTitle('Guardian Students')},
                    },
                ]
            },
        ]
    },

    // School
    {
        path: '/school',
        component: () => import(/* webpackChunkName: "school" */ '../views/school/Index.vue'),
        meta: { name: 'School', code: 'school', pageTitle: formatPageTitle('School')},
        children: [
            {
                path: '',
                component: () => import(/* webpackChunkName: "school" */ '../views/school/Schools.vue'),
                name: 'School',
                meta: { name: 'School', pageTitle: formatPageTitle('School'), keepAlive: true},
            },
            {
                path: 'add',
                component: () => import(/* webpackChunkName: "school" */ '../views/school/actions/Index.vue'),
                name: 'Add School',
                meta: { name: 'Add School', pageTitle: formatPageTitle('Add School')},
            },
            {
                path: ':id(\\d+)?/edit',
                component: () => import(/* webpackChunkName: "school" */ '../views/school/actions/Index.vue'),
                name: 'Edit School',
                meta: { name: 'Edit School', pageTitle: formatPageTitle('Edit School')},
            },
            {
                path: ':id(\\d+)?',
                component: () => import(/* webpackChunkName: "school" */ '../views/school/details/Index.vue'),
                meta: { name: 'School Details', pageTitle: formatPageTitle('School Details')},
                children: [
                    {
                        path: '',
                        component: () => import(/* webpackChunkName: "school" */ '../views/school/details/Details.vue'),
                        name: 'School Details',
                        meta: { name: 'School Details', tabname: 'overview', pageTitle: formatPageTitle('School Details')},
                    },
                    // {
                    //     path: 'students',
                    //     component: () => import(/* webpackChunkName: "school" */ '../views/school/details/Students.vue'),
                    //     name: 'School Students',
                    //     meta: { name: 'School Students', tabname: 'students', pageTitle: formatPageTitle('School Students')},
                    // },
                    {
                        path: 'grades',
                        component: () => import(/* webpackChunkName: "school" */ '../views/school/details/grades/Index.vue'),
                        name: 'School Grades',
                        meta: { name: 'School Grades', tabname: 'grades', pageTitle: formatPageTitle('School Grades')},
                    },
                    {
                        path: 'programs',
                        component: () => import(/* webpackChunkName: "school" */ '../views/school/details/programs/Index.vue'),
                        name: 'School Programs',
                        meta: { name: 'School Programs', tabname: 'programs', pageTitle: formatPageTitle('School Programs')},
                    },
                    {
                        path: 'program/:program_id(\\d+)?/students',
                        component: () => import(/* webpackChunkName: "school" */ '../views/school/details/programs/students/Index.vue'),
                        name: 'School Programs Students',
                        meta: { name: 'School Programs Students', tabname: 'programs', pageTitle: formatPageTitle('School Programs Students'), noCache: true},
                    },
                ]
            },
        ]
    },

    // Transporter
    {
        path: '/transporter',
        component: () => import(/* webpackChunkName: "transporter" */ '../views/transporter/Index.vue'),
        meta: { name: 'Transporter', code: 'transporter', pageTitle: formatPageTitle('Transporter')},
        children: [
            {
                path: '',
                component: () => import(/* webpackChunkName: "transporter" */ '../views/transporter/Transporters.vue'),
                name: 'Transporter',
                meta: { name: 'Transporter', pageTitle: formatPageTitle('Transporter'), keepAlive: true},
            },
            {
                path: 'add',
                component: () => import(/* webpackChunkName: "transporter" */ '../views/transporter/actions/Index.vue'),
                name: 'Add Transporter',
                meta: { name: 'Add Transporter', pageTitle: formatPageTitle('Add Transporter')},
            },
            {
                path: ':id(\\d+)?/edit',
                component: () => import(/* webpackChunkName: "transporter" */ '../views/transporter/actions/Index.vue'),
                name: 'Edit Transporter',
                meta: { name: 'Edit Transporter', pageTitle: formatPageTitle('Edit Transporter')},
            },
            {
                path: ':id(\\d+)?',
                component: () => import(/* webpackChunkName: "transporter" */ '../views/transporter/details/Index.vue'),
                meta: { name: 'Transporter Details', pageTitle: formatPageTitle('Transporter Details')},
                children: [
                    {
                        path: '',
                        component: () => import(/* webpackChunkName: "transporter" */ '../views/transporter/details/Details.vue'),
                        name: 'Transporter Details',
                        meta: { name: 'Transporter Details', tabname: 'overview', pageTitle: formatPageTitle('Transporter Details')},
                    },
                    // {
                    //     path: 'routes',
                    //     component: () => import(/* webpackChunkName: "transporter" */ '../views/transporter/details/Routes.vue'),
                    //     name: 'Transporter Routes',
                    //     meta: { name: 'Transporter Routes', tabname: 'students', pageTitle: formatPageTitle('Transporter Routes')},
                    // },
                ]
            },
        ]
    },

    // User
    {
        path: '/user',
        component: () => import(/* webpackChunkName: "user" */ '../views/user/Index.vue'),
        meta: { name: 'User', code: 'user', pageTitle: formatPageTitle('User')},
        children: [
            {
                path: '',
                component: () => import(/* webpackChunkName: "user" */ '../views/user/Users.vue'),
                name: 'User',
                meta: { name: 'User', pageTitle: formatPageTitle('User'), keepAlive: true},
            },
            {
                path: 'add',
                component: () => import(/* webpackChunkName: "user" */ '../views/user/actions/Index.vue'),
                name: 'Add User',
                meta: { name: 'Add User', pageTitle: formatPageTitle('Add User')},
            },
            {
                path: ':id(\\d+)?/edit',
                component: () => import(/* webpackChunkName: "user" */ '../views/user/actions/Index.vue'),
                name: 'Edit User',
                meta: { name: 'Edit User', pageTitle: formatPageTitle('Edit User')},
            },
            {
                path: ':id(\\d+)?',
                component: () => import(/* webpackChunkName: "user" */ '../views/user/details/Index.vue'),
                meta: { name: 'User Details', pageTitle: formatPageTitle('User Details')},
                children: [
                    {
                        path: '',
                        component: () => import(/* webpackChunkName: "user" */ '../views/user/details/Details.vue'),
                        name: 'User Details',
                        meta: { name: 'User Details', tabname: 'overview', pageTitle: formatPageTitle('User Details')},
                    },
                ]
            },
        ]
    },

    //Settings
    {
        path: '/settings',
        component: () => import(/* webpackChunkName: "settings" */ '../views/settings/Index.vue'),
        meta: { name: 'Settings', code: 'settings', pageTitle: formatPageTitle('Settings')},
        children: [
            {
                path: '',
                component: () => import(/* webpackChunkName: "settings" */ '../views/settings/details/Index.vue'),
                name: 'Settings',
                meta: { name: 'Settings', pageTitle: formatPageTitle('Settings')},
            },
            {
                path: 'edit',
                component: () => import(/* webpackChunkName: "settings" */ '../views/settings/actions/Index.vue'),
                name: 'Edit Settings',
                meta: { name: 'Edit Settings', pageTitle: formatPageTitle('Edit Settings')},
            }
        ]
    },

    //Emergency
    {
        path: '/emergency',
        component: () => import(/* webpackChunkName: "emergency" */ '../views/emergency/Index.vue'),
        meta: { name: 'Emergency', code: 'emergency', pageTitle: formatPageTitle('Emergency')},
        children: [
            {
                path: '',
                component: () => import(/* webpackChunkName: "emergency" */ '../views/emergency/Emergency.vue'),
                name: 'Emergency',
                meta: { name: 'Emergency', pageTitle: formatPageTitle('Emergency'), keepAlive: true},
            },
            {
                path: ':id(\\d+)?',
                component: () => import(/* webpackChunkName: "emergency" */ '../views/emergency/details/Index.vue'),
                meta: { name: 'Emergency Details', pageTitle: formatPageTitle('Emergency Details')},
                children: [
                    {
                        path: '',
                        component: () => import(/* webpackChunkName: "emergency" */ '../views/emergency/details/Details.vue'),
                        name: 'Emergency Details',
                        meta: { name: 'Emergency Details', tabname: 'overview', pageTitle: formatPageTitle('Emergency Details')},
                    },
                ]
            },
            {
                path: 'settings',
                component: () => import(/* webpackChunkName: "emergency" */ '../views/emergency/settings/Index.vue'),
                meta: { name: 'Emergency Settings', pageTitle: formatPageTitle('Emergency Settings')},
                children: [
                    {
                        path: '',
                        component: () => import(/* webpackChunkName: "emergency" */ '../views/emergency/settings/EmergencySettings.vue'),
                        name: 'Emergency Settings',
                        meta: { name: 'Emergency Settings', pageTitle: formatPageTitle('Emergency Settings'), keepAlive: true},
                    },
                    {
                        path: 'add',
                        component: () => import(/* webpackChunkName: "emergency" */ '../views/emergency/settings/actions/Index.vue'),
                        name: 'Add Emergency Settings',
                        meta: { name: 'Add Emergency Settings', pageTitle: formatPageTitle('Add Emergency Settings')},
                    },
                    {
                        path: ':id(\\d+)?/edit',
                        component: () => import(/* webpackChunkName: "emergency" */ '../views/emergency/settings/actions/Index.vue'),
                        name: 'Edit Emergency Settings',
                        meta: { name: 'Edit Emergency Settings', pageTitle: formatPageTitle('Edit Emergency Settings')},
                    },
                    {
                        path: ':id(\\d+)?',
                        component: () => import(/* webpackChunkName: "emergency" */ '../views/emergency/settings/details/Index.vue'),
                        meta: { name: 'Emergency Settings Detail', pageTitle: formatPageTitle('Emergency Settings Detail')},
                        children: [
                            {
                                path: '',
                                component: () => import(/* webpackChunkName: "emergency" */ '../views/emergency/settings/details/Details.vue'),
                                name: 'Emergency Settings Detail',
                                meta: { name: 'Emergency Settings Detail', tabname: 'overview', pageTitle: formatPageTitle('Emergency Settings Detail')},
                            },
                        ]
                    },
                ]
            }
        ]
    },

    // Route
    {
        path: '/route',
        component: () => import(/* webpackChunkName: "route" */ '../views/route/Index.vue'),
        meta: { name: 'Route', code: 'route', pageTitle: formatPageTitle('Route')},
        children: [
            {
                path: '',
                component: () => import(/* webpackChunkName: "route" */ '../views/route/Routes.vue'),
                name: 'Route',
                meta: { name: 'Route', pageTitle: formatPageTitle('Route'), keepAlive: true},
            },
            {
                path: 'add',
                component: () => import(/* webpackChunkName: "route" */ '../views/route/actions/Index.vue'),
                name: 'Add Route',
                meta: { name: 'Add Route', pageTitle: formatPageTitle('Add Route')},
            },
            {
                path: ':id(\\d+)?/edit',
                component: () => import(/* webpackChunkName: "route" */ '../views/route/actions/Index.vue'),
                name: 'Edit Route',
                meta: { name: 'Edit Route', pageTitle: formatPageTitle('Edit Route')},
            },
            {
                path: ':id(\\d+)?/duplicate',
                component: () => import(/* webpackChunkName: "route" */ '../views/route/actions/Duplicate.vue'),
                name: 'Duplicate Route',
                meta: { name: 'Duplicate Route', pageTitle: formatPageTitle('Duplicate Route')},
            },
            {
                path: ':id(\\d+)?',
                component: () => import(/* webpackChunkName: "route" */ '../views/route/details/Index.vue'),
                meta: { name: 'Route Details', pageTitle: formatPageTitle('Route Details')},
                children: [
                    {
                        path: '',
                        component: () => import(/* webpackChunkName: "route" */ '../views/route/details/Details.vue'),
                        name: 'Route Details',
                        meta: { name: 'Route Details', tabname: 'overview', pageTitle: formatPageTitle('Route Details')},
                    },
                    {
                        path: 'settings',
                        component: () => import(/* webpackChunkName: "route" */ '../views/route/details/Settings.vue'),
                        name: 'Route Settings',
                        meta: { name: 'Route Settings', tabname: 'settings', pageTitle: formatPageTitle('Route Settings')},
                    },
                    {
                        path: 'manifest',
                        component: () => import(/* webpackChunkName: "route" */ '../views/route/details/Manifest.vue'),
                        name: 'Route Manifest',
                        meta: { name: 'Route Manifest', tabname: 'manifest', pageTitle: formatPageTitle('Route Manifest')},
                    },
                    {
                        path: 'map',
                        component: () => import(/* webpackChunkName: "route" */ '../views/route/details/Map.vue'),
                        name: 'Route Map',
                        meta: { name: 'Route Map', tabname: 'map', pageTitle: formatPageTitle('Route Map')},
                    },
                    {
                        path: 'trip_history',
                        component: () => import(/* webpackChunkName: "route" */ '../views/route/details/History.vue'),
                        name: 'Route History',
                        meta: { name: 'Route History', tabname: 'trip_history', pageTitle: formatPageTitle('Route History')},
                    },
                ]
            },
        ]
    },

    // Trip
    {
        path: '/trip',
        component: () => import(/* webpackChunkName: "trip" */ '../views/trip/Index.vue'),
        meta: { name: 'Trip', code: 'trip', pageTitle: formatPageTitle('Trip')},
        children: [
            {
                path: '',
                component: () => import(/* webpackChunkName: "trip" */ '../views/trip/Trips.vue'),
                name: 'Trip',
                meta: { name: 'Trip', pageTitle: formatPageTitle('Trip'), keepAlive: true},
            },
            {
                path: 'add',
                component: () => import(/* webpackChunkName: "trip" */ '../views/trip/actions/Index.vue'),
                name: 'Add Trip',
                meta: { name: 'Add Trip', pageTitle: formatPageTitle('Add Trip')},
            },
            {
                path: ':id(\\d+)?',
                component: () => import(/* webpackChunkName: "trip" */ '../views/trip/details/Index.vue'),
                meta: { name: 'Trip Details', pageTitle: formatPageTitle('Trip Details')},
                children: [
                    {
                        path: '',
                        component: () => import(/* webpackChunkName: "trip" */ '../views/trip/details/Details.vue'),
                        name: 'Trip Details',
                        meta: { name: 'Trip Details', tabname: 'overview', pageTitle: formatPageTitle('Trip Details')},
                    },
                    {
                        path: 'arrivals',
                        component: () => import(/* webpackChunkName: "trip" */ '../views/trip/details/Arrivals.vue'),
                        name: 'Trip Arrivals',
                        meta: { name: 'Trip Arrivals', tabname: 'arrivals', pageTitle: formatPageTitle('Trip Arrivals')},
                    },
                    {
                        path: 'manifest',
                        component: () => import(/* webpackChunkName: "trip" */ '../views/trip/details/Manifest.vue'),
                        name: 'Trip Manifest',
                        meta: { name: 'Trip Manifest', tabname: 'manifest', pageTitle: formatPageTitle('Trip Manifest')},
                    },
                    {
                        path: 'scheduled_students',
                        component: () => import(/* webpackChunkName: "trip" */ '../views/trip/details/ScheduledStudents.vue'),
                        name: 'Trip Scheduled Students',
                        meta: { name: 'Trip Scheduled Students', tabname: 'scheduled_students', pageTitle: formatPageTitle('Trip Scheduled Students')},
                    },
                    {
                        path: 'un_scheduled_students',
                        component: () => import(/* webpackChunkName: "trip" */ '../views/trip/details/UnScheduledStudents.vue'),
                        name: 'Trip Un-Scheduled Students',
                        meta: { name: 'Trip Un-Scheduled Students', tabname: 'un_scheduled_students', pageTitle: formatPageTitle('Trip Un-Scheduled Students')},
                    },
                    {
                        path: 'logs',
                        component: () => import(/* webpackChunkName: "trip" */ '../views/trip/details/Logs.vue'),
                        name: 'Trip Logs',
                        meta: { name: 'Trip Un-Scheduled Students', tabname: 'logs', pageTitle: formatPageTitle('Trip Logs')},
                    },
                    {
                        path: 'settings',
                        component: () => import(/* webpackChunkName: "trip" */ '../views/trip/details/Settings.vue'),
                        name: 'Trip Settings',
                        meta: { name: 'Trip Settings', tabname: 'settings', pageTitle: formatPageTitle('Trip Settings')},
                    },
                    {
                        path: 'replay',
                        component: () => import(/* webpackChunkName: "trip" */ '../views/trip/details/Replay.vue'),
                        name: 'Trip Replay',
                        meta: { name: 'Trip Replay', tabname: 'replay', pageTitle: formatPageTitle('Trip Replay'), fullScreen: true},
                    },
                ]
            },
        ]
    },

    // Message
    {
        path: '/message',
        component: () => import(/* webpackChunkName: "message" */ '../views/message/Index.vue'),
        meta: { name: 'Message', code: 'message', pageTitle: formatPageTitle('Message')},
        children: [
            {
                path: '',
                component: () => import(/* webpackChunkName: "message" */ '../views/message/Messages.vue'),
                name: 'Message',
                meta: { name: 'Message', pageTitle: formatPageTitle('Message'), keepAlive: true},
            },
            {
                path: 'add',
                component: () => import(/* webpackChunkName: "message" */ '../views/message/actions/Index.vue'),
                name: 'Add Message',
                meta: { name: 'Add Message', pageTitle: formatPageTitle('Add Message')},
            },
            {
                path: ':id(\\d+)?/edit',
                component: () => import(/* webpackChunkName: "message" */ '../views/message/actions/Index.vue'),
                name: 'Edit Message',
                meta: { name: 'Edit Message', pageTitle: formatPageTitle('Edit Message')},
            },
            {
                path: ':id(\\d+)?',
                component: () => import(/* webpackChunkName: "message" */ '../views/message/details/Index.vue'),
                meta: { name: 'Message Details', pageTitle: formatPageTitle('Message Details')},
                children: [
                    {
                        path: '',
                        component: () => import(/* webpackChunkName: "message" */ '../views/message/details/Details.vue'),
                        name: 'Message Details',
                        meta: { name: 'Message Details', tabname: 'overview', pageTitle: formatPageTitle('Message Details')},
                    },
                ]
            },
        ]
    },

    // Inspection
    {
        path: '/inspection',
        component: () => import(/* webpackChunkName: "inspection" */ '../views/inspection/Index.vue'),
        meta: { name: 'Inspection', code: 'inspection', pageTitle: formatPageTitle('Inspection')},
        children: [
            {
                path: '',
                component: () => import(/* webpackChunkName: "inspection" */ '../views/inspection/Inspections.vue'),
                name: 'Inspection',
                meta: { name: 'Inspection', pageTitle: formatPageTitle('Inspection'), keepAlive: true},
            },
            {
                path: ':id(\\d+)?',
                component: () => import(/* webpackChunkName: "inspection" */ '../views/inspection/details/Index.vue'),
                meta: { name: 'Inspection Details', pageTitle: formatPageTitle('Inspection Details')},
                children: [
                    {
                        path: '',
                        component: () => import(/* webpackChunkName: "inspection" */ '../views/inspection/details/Details.vue'),
                        name: 'Inspection Details',
                        meta: { name: 'Inspection Details', tabname: 'overview', pageTitle: formatPageTitle('Inspection Details')},
                    },
                    {
                        path: 'manifest',
                        component: () => import(/* webpackChunkName: "inspection" */ '../views/inspection/details/Manifest.vue'),
                        name: 'Inspection Manifest',
                        meta: { name: 'Inspection Manifest', tabname: 'manifest', pageTitle: formatPageTitle('Inspection Manifest'), fullScreen: true},
                    },
                ]
            },
        ]
    },
    {
        path: '/inspection-form',
        component: () => import(/* webpackChunkName: "inspection" */ '../views/inspection-settings/form/Index.vue'),
        meta: { name: 'Inspection Form', code: 'inspection', pageTitle: formatPageTitle('Inspection Form')},
        children: [
            {
                path: '',
                component: () => import(/* webpackChunkName: "inspection" */ '../views/inspection-settings/form/Forms.vue'),
                name: 'Inspection Form',
                meta: { name: 'Inspection Form', pageTitle: formatPageTitle('Inspection Form'), keepAlive: true},
            },
            {
                path: 'add',
                component: () => import(/* webpackChunkName: "inspection" */ '../views/inspection-settings/form/actions/Index.vue'),
                name: 'Add Inspection Form',
                meta: { name: 'Add Inspection Form', pageTitle: formatPageTitle('Add Inspection Form')},
            },
            {
                path: ':id(\\d+)?/edit',
                component: () => import(/* webpackChunkName: "inspection" */ '../views/inspection-settings/form/actions/Index.vue'),
                name: 'Edit Inspection Form',
                meta: { name: 'Edit Inspection Form', pageTitle: formatPageTitle('Edit Inspection Form')},
            },
            {
                path: ':id(\\d+)?',
                component: () => import(/* webpackChunkName: "inspection" */ '../views/inspection-settings/form/details/Index.vue'),
                meta: { name: 'Inspection Form Detail', pageTitle: formatPageTitle('Inspection Form Detail')},
                children: [
                    {
                        path: '',
                        component: () => import(/* webpackChunkName: "inspection" */ '../views/inspection-settings/form/details/Details.vue'),
                        name: 'Inspection Form Detail',
                        meta: { name: 'Inspection Form Detail', tabname: 'overview', pageTitle: formatPageTitle('Inspection Form Detail')},
                    },
                    {
                        path: 'points',
                        component: () => import(/* webpackChunkName: "inspection" */ '../views/inspection-settings/form/details/points/Index.vue'),
                        name: 'Inspection Form Points',
                        meta: { name: 'Inspection Form Points', tabname: 'points', pageTitle: formatPageTitle('Inspection Form Points')},
                    },
                ]
            },
        ]
    },
    {
        path: '/inspection-point',
        component: () => import(/* webpackChunkName: "inspection" */ '../views/inspection-settings/point/Index.vue'),
        meta: { name: 'Inspection Point', code: 'inspection', pageTitle: formatPageTitle('Inspection Point')},
        children: [
            {
                path: '',
                component: () => import(/* webpackChunkName: "inspection" */ '../views/inspection-settings/point/Points.vue'),
                name: 'Inspection Point',
                meta: { name: 'Inspection Point', pageTitle: formatPageTitle('Inspection Point'), keepAlive: true},
            },
            {
                path: 'add',
                component: () => import(/* webpackChunkName: "inspection" */ '../views/inspection-settings/point/actions/Index.vue'),
                name: 'Add Inspection Point',
                meta: { name: 'Add Inspection Point', pageTitle: formatPageTitle('Add Inspection Point')},
            },
            {
                path: ':id(\\d+)?/edit',
                component: () => import(/* webpackChunkName: "inspection" */ '../views/inspection-settings/point/actions/Index.vue'),
                name: 'Edit Inspection Point',
                meta: { name: 'Edit Inspection Point', pageTitle: formatPageTitle('Edit Inspection Point')},
            },
            {
                path: ':id(\\d+)?',
                component: () => import(/* webpackChunkName: "inspection" */ '../views/inspection-settings/point/details/Index.vue'),
                meta: { name: 'Inspection Point Detail', pageTitle: formatPageTitle('Inspection Point Detail')},
                children: [
                    {
                        path: '',
                        component: () => import(/* webpackChunkName: "inspection" */ '../views/inspection-settings/point/details/Details.vue'),
                        name: 'Inspection Point Detail',
                        meta: { name: 'Inspection Point Detail', tabname: 'overview', pageTitle: formatPageTitle('Inspection Point Detail')},
                    },
                    {
                        path: 'Defects',
                        component: () => import(/* webpackChunkName: "inspection" */ '../views/inspection-settings/point/details/defects/Index.vue'),
                        name: 'Inspection Point Defects',
                        meta: { name: 'Inspection Point Defects', tabname: 'defects', pageTitle: formatPageTitle('Inspection Point Defects')},
                    },
                ]
            },
        ]
    },
    {
        path: '/inspection-defect',
        component: () => import(/* webpackChunkName: "inspection" */ '../views/inspection-settings/defect/Index.vue'),
        meta: { name: 'Inspection Defect', code: 'inspection', pageTitle: formatPageTitle('Inspection Defect')},
        children: [
            {
                path: '',
                component: () => import(/* webpackChunkName: "inspection" */ '../views/inspection-settings/defect/Defects.vue'),
                name: 'Inspection Defect',
                meta: { name: 'Inspection Defect', pageTitle: formatPageTitle('Inspection Defect'), keepAlive: true},
            },
            {
                path: 'add',
                component: () => import(/* webpackChunkName: "inspection" */ '../views/inspection-settings/defect/actions/Index.vue'),
                name: 'Add Inspection Defect',
                meta: { name: 'Add Inspection Defect', pageTitle: formatPageTitle('Add Inspection Defect')},
            },
            {
                path: ':id(\\d+)?/edit',
                component: () => import(/* webpackChunkName: "inspection" */ '../views/inspection-settings/defect/actions/Index.vue'),
                name: 'Edit Inspection Defect',
                meta: { name: 'Edit Inspection Defect', pageTitle: formatPageTitle('Edit Inspection Defect')},
            },
            {
                path: ':id(\\d+)?',
                component: () => import(/* webpackChunkName: "inspection" */ '../views/inspection-settings/defect/details/Index.vue'),
                meta: { name: 'Inspection Defect Detail', pageTitle: formatPageTitle('Inspection Defect Detail')},
                children: [
                    {
                        path: '',
                        component: () => import(/* webpackChunkName: "inspection" */ '../views/inspection-settings/defect/details/Details.vue'),
                        name: 'Inspection Defect Detail',
                        meta: { name: 'Inspection Defect Detail', tabname: 'overview', pageTitle: formatPageTitle('Inspection Defect Detail')},
                    },
                ]
            },
        ]
    },
    {
        path: '/inspection-defect-type',
        component: () => import(/* webpackChunkName: "inspection" */ '../views/inspection-settings/defect-type/Index.vue'),
        meta: { name: 'Inspection Defect Type', code: 'inspection', pageTitle: formatPageTitle('Inspection Defect Type')},
        children: [
            {
                path: '',
                component: () => import(/* webpackChunkName: "inspection" */ '../views/inspection-settings/defect-type/DefectTypes.vue'),
                name: 'Inspection Defect Type',
                meta: { name: 'Inspection Defect Type', pageTitle: formatPageTitle('Inspection Defect Type'), keepAlive: true},
            },
            {
                path: 'add',
                component: () => import(/* webpackChunkName: "inspection" */ '../views/inspection-settings/defect-type/actions/Index.vue'),
                name: 'Add Inspection Defect Type',
                meta: { name: 'Add Inspection Defect Type', pageTitle: formatPageTitle('Add Inspection Defect Type')},
            },
            {
                path: ':id(\\d+)?/edit',
                component: () => import(/* webpackChunkName: "inspection" */ '../views/inspection-settings/defect-type/actions/Index.vue'),
                name: 'Edit Inspection Defect Type',
                meta: { name: 'Edit Inspection Defect Type', pageTitle: formatPageTitle('Edit Inspection Defect Type')},
            },
            {
                path: ':id(\\d+)?',
                component: () => import(/* webpackChunkName: "inspection" */ '../views/inspection-settings/defect-type/details/Index.vue'),
                meta: { name: 'Inspection Defect Type Detail', pageTitle: formatPageTitle('Inspection Defect Type Detail')},
                children: [
                    {
                        path: '',
                        component: () => import(/* webpackChunkName: "inspection" */ '../views/inspection-settings/defect-type/details/Details.vue'),
                        name: 'Inspection Defect Type Detail',
                        meta: { name: 'Inspection Defect Type Detail', tabname: 'overview', pageTitle: formatPageTitle('Inspection Defect Type Detail')},
                    },
                ]
            },
        ]
    },
    {
        path: '/report',
        component: () => import(/* webpackChunkName: "reports" */ '../views/reports/Index.vue'),
        meta: { name: 'Reports', code: 'report', pageTitle: formatPageTitle('Report')},
        children: [
            {
                path: '',
                component: () => import(/* webpackChunkName: "reports" */ '../views/reports/Report.vue'),
                name: 'Reports',
                meta: { name: 'Reports', pageTitle: formatPageTitle('Reports'), keepAlive: true},
            },
            {
                path: 'route/detail_ridership',
                component: () => import(/* webpackChunkName: "reports" */ '../views/reports/detailed-ridership/Index.vue'),
                name: 'DetailedRidership',
                meta: { name: 'DetailedRidership', pageTitle: formatPageTitle('Detailed Ridership'), keepAlive: true},
            },
            {
                path: 'route/summary_ridership',
                component: () => import(/* webpackChunkName: "reports" */ '../views/reports/summary-ridership/Index.vue'),
                name: 'SummaryRidership',
                meta: { name: 'SummaryRidership', pageTitle: formatPageTitle('Summary Ridership'), keepAlive: true},
            },
            {
                path: 'route/route_performance',
                component: () => import(/* webpackChunkName: "reports" */ '../views/reports/route-ontime-performance/Index.vue'),
                name: 'RoutePerformance',
                meta: { name: 'RoutePerformance', pageTitle: formatPageTitle('Route Ontime Performance'), keepAlive: true},
            },
            {
                path: 'route/stop_avg_arrival_time',
                component: () => import(/* webpackChunkName: "reports" */ '../views/reports/stop-avg-arrival-time/Index.vue'),
                name: 'StopAvgArrivalTime',
                meta: { name: 'StopAvgArrivalTime', pageTitle: formatPageTitle('Stop Avg Arrival Time'), keepAlive: true},
            },
            {
                path: 'student/lost_card',
                component: () => import(/* webpackChunkName: "reports" */ '../views/reports/lost-cards/Index.vue'),
                name: 'LostCard',
                meta: { name: 'LostCard', pageTitle: formatPageTitle('Lost Card'), keepAlive: true},
            },
            {
                path: 'student/student_cico',
                component: () => import(/* webpackChunkName: "reports" */ '../views/reports/student-cico/Index.vue'),
                name: 'StudentCICO',
                meta: { name: 'Student CICO', pageTitle: formatPageTitle('Student CICO'), keepAlive: true},
            },
            {
                path: 'student/unsched_student_cico',
                component: () => import(/* webpackChunkName: "reports" */ '../views/reports/unsched-student-cico/Index.vue'),
                name: 'UnschedStudentCICO',
                meta: { name: 'Unsched Student CICO', pageTitle: formatPageTitle('Unsched Student CICO'), keepAlive: true},
            },
            {
                path: 'student/student_busing',
                component: () => import(/* webpackChunkName: "reports" */ '../views/reports/student-busing/Index.vue'),
                name: 'StudentBusing',
                meta: { name: 'Student Busing', pageTitle: formatPageTitle('Student Busing'), keepAlive: true},
            },
            {
                path: 'driver/attendance',
                component: () => import(/* webpackChunkName: "reports" */ '../views/reports/driver-attendance/Index.vue'),
                name: 'DriverAttendance',
                meta: { name: 'Driver Attendance', pageTitle: formatPageTitle('Driver Attendance'), keepAlive: true},
            },
            {
                path: 'driver/inspections',
                component: () => import(/* webpackChunkName: "reports" */ '../views/reports/driver-inspections/Index.vue'),
                name: 'DriverInspections',
                meta: { name: 'Driver Inspections', pageTitle: formatPageTitle('Driver Inspections'), keepAlive: true},
            },
            {
                path: 'driver/performance',
                component: () => import(/* webpackChunkName: "reports" */ '../views/reports/driver-performance/Index.vue'),
                name: 'DriverPerformance',
                meta: { name: 'Driver Performance', pageTitle: formatPageTitle('Driver Performance'), keepAlive: true},
            },
            {
                path: 'bus/inspections',
                component: () => import(/* webpackChunkName: "reports" */ '../views/reports/bus-inspections/Index.vue'),
                name: 'BusInspections',
                meta: { name: 'Bus Inspections', pageTitle: formatPageTitle('Bus Inspections'), keepAlive: true},
            },
            {
                path: 'bus/overspeed',
                component: () => import(/* webpackChunkName: "reports" */ '../views/reports/bus-overspeed/Index.vue'),
                name: 'BusOverspeed',
                meta: { name: 'Bus Overspeed', pageTitle: formatPageTitle('Bus Overspeed'), keepAlive: true},
            },
        ]
    },

    // Card
    {
        path: '/card',
        component: () => import(/* webpackChunkName: "card" */ '../views/card/Index.vue'),
        meta: { name: 'Card', code: 'card', pageTitle: formatPageTitle('Card')},
        children: [
            {
                path: '',
                component: () => import(/* webpackChunkName: "card" */ '../views/card/Cards.vue'),
                name: 'Card',
                meta: { name: 'Card', pageTitle: formatPageTitle('Card'), keepAlive: true},
            },
            {
                path: 'add',
                component: () => import(/* webpackChunkName: "card" */ '../views/card/actions/Index.vue'),
                name: 'Add Card',
                meta: { name: 'Add Card', pageTitle: formatPageTitle('Add Card')},
            },
            {
                path: ':id(\\d+)?/edit',
                component: () => import(/* webpackChunkName: "card" */ '../views/card/actions/Index.vue'),
                name: 'Edit Card',
                meta: { name: 'Edit Card', pageTitle: formatPageTitle('Edit Card')},
            },
            {
                path: ':id(\\d+)?',
                component: () => import(/* webpackChunkName: "card" */ '../views/card/details/Index.vue'),
                meta: { name: 'Card Details', pageTitle: formatPageTitle('Card Details')},
                children: [
                    {
                        path: '',
                        component: () => import(/* webpackChunkName: "card" */ '../views/card/details/Details.vue'),
                        name: 'Card Details',
                        meta: { name: 'Card Details', tabname: 'overview', pageTitle: formatPageTitle('Card Details')},
                    },
                    {
                        path: 'check-on-off',
                        component: () => import(/* webpackChunkName: "card" */ '../views/card/details/CheckOnOff.vue'),
                        name: 'Card Check On & Off',
                        meta: { name: 'Card Check On & Off', tabname: 'check-on-off', pageTitle: formatPageTitle('Card Check On & Off')},
                    },
                    {
                        path: 'history',
                        component: () => import(/* webpackChunkName: "card" */ '../views/card/details/History.vue'),
                        name: 'Card History',
                        meta: { name: 'Card History', tabname: 'history', pageTitle: formatPageTitle('Card History')},
                    },
                ]
            },
        ]
    },

    // Global
    {
        path: '/global_search',
        component: () => import(/* webpackChunkName: "global-search" */ '../views/global-search/Index.vue'),
        meta: { name: 'GlobalSearch', code: 'global_search', pageTitle: formatPageTitle('Global Search')},
        redirect: '/global_search/student',
        children: [
            {
                path: 'student',
                component: () => import(/* webpackChunkName: "global-search" */ '../views/global-search/Students.vue'),
                name: 'GlobalSearchStudents',
                meta: { name: 'GlobalSearchStudents', pageTitle: formatPageTitle('Global Search Students')},
            },
            {
                path: 'bus',
                component: () => import(/* webpackChunkName: "global-search" */ '../views/global-search/Buses.vue'),
                name: 'GlobalSearchBuses',
                meta: { name: 'GlobalSearchBuses', pageTitle: formatPageTitle('Global Search Buses')},
            },
        ]
    },
]

export default asyncRouters